import styled from "styled-components";

import { media } from "../../../styles/media";

export const RegisterStepTwoFormStyles = styled.div`
  .alignedInputs {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .inputContainer {
      width: 186px;
    }

    ${media.maxMobile`
      flex-direction: column;
      align-items: stretch;
      gap: 12px;

      .inputContainer {
        width: 100%;
      }
    `}
  }

  .backButton {
    position: absolute;
    padding: 9px 14px;
    top: -19px;
    display: flex;
    align-items: center;

    .arrowContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      transform: rotate(-90deg);
      padding-top: 2.5px;
    }
  }

  .form {
    margin-top: 31px;

    .stateDropdown {
      background: #fafbfc;
      border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    }

    .submitButton {
      width: 100%;
    }
  }
`;
